'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-switch/lib/index.js
 ** module id = 648
 ** module chunks = 0
 **/